<div class="modal-component">
    <div class="modal-header-content">
        <div class="header-text-container">
            <div class="header-text">
                Rezeptvorschau
            </div>
        </div>
        <button class="modal-close-button" type="button" (click)="onClose()">
            <i class="fa-solid fa-times icon-center"></i>
        </button>
    </div>
    <div class="modal-body-container">
        <div class="form-group">
            <div class="form-control">
                <mat-select [formControl]="prescriptionTypeControl" (selectionChange)="changePreviewType()" class="custom-select">
                    @for (prescriptionType of prescriptionTypeList; track prescriptionType.id) {
                        <mat-option [value]="prescriptionType.id"> {{prescriptionType.description}} </mat-option>
                    }
                </mat-select>
            </div>
        </div>
        @if (pdfUrl !== '') {
            <div class="prescription-preview">
                <img [src]="'data:image/png;base64,' + prescriptionPreviewBase64String" alt="Rezeptvorschau">
            </div>
        }
    </div>
    <div class="modal-button-container">
        <button type="button" class="btn tertiary-button" (click)="onClose()">Abbrechen</button>
        @if(isPublished) {
            <button type="button" class="btn primary-button" (click)="onSubmit()">Rezept herunterladen</button>
        } @else {
            <button type="button" class="btn primary-button" [disabled]="!buttonActive" (click)="onSubmit()">Rezept speichern und herunterladen</button>
        }
    </div>
</div>
